// extracted by mini-css-extract-plugin
export default {"tableRow":"propertyList_tableRow__zVBvA","tableCell":"propertyList_tableCell__4BGwr"};